import { Link } from "react-router-dom";

import CollapseHeader from "../../../../../core/common/collapse-header/collapse-header";

interface ExecutionHistoryHeaderProps {
  title: string;
  breadcrumb: string;
  callingBreadcrumb: string;
  dashboardRoute: string;
  backRoute: string;
}

const ExecutionHistoryHeader: React.FC<ExecutionHistoryHeaderProps> = ({
  title,
  breadcrumb,
  callingBreadcrumb,
  dashboardRoute,
  backRoute,
}) => (
  <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div className="my-auto mb-2">
      <h2 className="mb-1">{title}</h2>
      <nav>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <Link to={dashboardRoute}>
              <i className="ti ti-smart-home" />
            </Link>
          </li>
          <li className="breadcrumb-item">Automations</li>
          <li className="breadcrumb-item">
            <Link to={backRoute}>{callingBreadcrumb}</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {breadcrumb}
          </li>
        </ol>
      </nav>
    </div>

    <div className="d-flex align-items-center ms-auto flex-wrap gap-2 mb-2">
      <Link
        to={backRoute}
        className="btn btn-primary d-inline-flex align-items-center"
        style={{ minHeight: 38 }}
      >
        <i className="ti ti-arrow-left me-1" />
        Back to Workflows
      </Link>
      <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
        <div className="head-icons mb-0">
          <CollapseHeader />
        </div>
      </div>
    </div>
  </div>
);

export default ExecutionHistoryHeader;
